import React from 'react';

export default function ForgotPassword() {
  const isMobileDevice = () => {
    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
  };

  const getUrlParams = () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const email = urlParams.get('email') ?? '';
    const confirmation_code = urlParams.get('confirmation_code') ?? '';
    if (isMobileDevice()) {
      window.location = `therabody://forgot/${email}/${confirmation_code}`;
    }
  };

  const successRender = () => {
    if (isMobileDevice()) {
      setTimeout(() => {
        window.close();
      }, 1000);
      getUrlParams();
    } else {
      return (
        <div>
          <p>A password reset link has been sent to your email address.</p>
          <p>You can close this window.</p>
        </div>
      );
    }
    return null; // Render nothing for mobile as it redirects
  };

  return (
    <div>
      {successRender()}
    </div>
  );
}
